import { useState } from "react";
import { Star } from "lucide-react";

export function StarRating({ onRate, disabled, size = 28, testid = "star-rating" }) {
  const [hover, setHover] = useState(0);
  const [value, setValue] = useState(0);
  return (
    <div className="flex gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" disabled={disabled} data-testid={`${testid}-${n}`}
                onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)}
                onClick={() => { setValue(n); onRate?.(n); }}
                className="transition-transform hover:scale-110">
          <Star size={size} className={(hover || value) >= n ? "fill-brass text-brass" : "text-brass/40"} />
        </button>
      ))}
    </div>
  );
}

export default StarRating;
